import { cn } from '../../lib/cn';
import type { RiskRow } from '../../enterpriseaigovernance/framework';

type Props = { items?: RiskRow[] };

export function ResponsibleAIRiskPanel({ items = [] }: Props) {
  return (
    <div className="grid gap-2 sm:grid-cols-2">
      {items.map((item) => (
        <div key={item.category} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-2">
            <p className="text-sm font-medium">{item.category}</p>
            <span className={cn(
              'rounded-full px-2 py-0.5 text-xs font-medium',
              item.status === 'compliant' || item.status === 'validated' || item.status === 'enforced'
                ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300'
                : 'bg-brand-50 text-brand-700 dark:bg-brand-950 dark:text-brand-300',
            )}>
              {item.status}
            </span>
          </div>
          <p className="mt-1 text-xs text-slate-500">{item.control}</p>
          <div className="mt-2 h-2 overflow-hidden rounded-full bg-slate-100 dark:bg-slate-800">
            <div className={cn('h-full rounded-full', item.score >= 95 ? 'bg-success-500' : 'bg-brand-500')} style={{ width: `${item.score}%` }} />
          </div>
        </div>
      ))}
    </div>
  );
}
